import type { FC } from 'react'

type PipelineInstructionsProps = {
  pipelineId: string
}

const PipelineInstructions: FC<PipelineInstructionsProps> = ({ pipelineId }) => {
  const instructionsHash = {
    north_star_framework: 'Get started by entering a company name',
    okr_map: 'Get started by entering a company name',
    software_experience_map: 'Get started by entering a company name'
  }

  const instructions = instructionsHash[pipelineId]

  if (!instructions) {
    return 'How can I help you?'
  }

  return instructions
}

export default PipelineInstructions
